// 全民K歌
const zsxxwRoutes = Array.from({ length: 14 }, (_, i) => ({
  path: `oldStudy/zsxxw/index${i + 1}`,
  name: `oldStudy/zsxxw/Index${i + 1}`,
  component: () => import(`@/views/study/oldStudy/zsxxw/index${i + 1}.vue`)
}))


import oldStudyIndex from '@/views/study/oldStudy/index'



export default {
  path: '/study',
  component: {
    render (c) {
      return c('router-view')
    }
  },
  children: [
      {
        path: 'oldStudy/index',
        name: 'oldStudyIndex',
        component: oldStudyIndex
      },
    // 全民K歌，开始
    ...zsxxwRoutes,
    // 全民K歌，结束


  ],
};
